"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSitemap = void 0;
const buildUrlTemplate = (host, locale, defaultLocale) => `${host}${locale !== defaultLocale ? `/${locale}` : ""}`;
const linkAlternateTemplate = (options, path) => {
    return options.locales
        .map((locale) => `<link rel="alternate" hreflang="${locale}" href="${path.replace(options.startPathToSubstitute, buildUrlTemplate(options.host, locale, options.defaultLocale))}"/>`)
        .join("");
};
const sitemapTemplate = (options) => {
    return `
        <?xml version="1.0" encoding="UTF-8"?>
        <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">
            ${options.paths
        .map((path) => {
        const alternateUrls = linkAlternateTemplate(options, path);
        const startOfTheDay = new Date();
        startOfTheDay.setUTCHours(0, 0, 0, 0);
        return `
                    <url>
                        <loc>${path.replace(options.startPathToSubstitute, buildUrlTemplate(options.host, options.defaultLocale, options.defaultLocale))}</loc>                                      
                        <lastmod>${startOfTheDay.toISOString()}</lastmod>
                        <changefreq>daily</changefreq>
                        <priority>1.0</priority>
                        ${alternateUrls}                         
                    </url>`;
    })
        .join("")}
        </urlset>`;
};
const generateSitemap = (options) => {
    const sitemap = sitemapTemplate(options);
    return sitemap.trim();
};
exports.generateSitemap = generateSitemap;
//# sourceMappingURL=template.js.map